import isNil from 'lodash/isNil'
import React from 'react'
import styled from 'styled-components'
import {
  GeckoRiskAssessmentConfig,
  getRiskBackgroundColor,
  getRiskColor,
  mapRiskScoreToRiskClass,
} from 'types'
import { getRiskLevelText } from 'utils/fde/conversionHelpers'

const Badge = styled.div<{
  $riskLevel: string
  $riskAssessmentConfig?: GeckoRiskAssessmentConfig
  $clickable?: boolean
}>`
  background-color: ${({ $riskLevel, $riskAssessmentConfig }) =>
    getRiskBackgroundColor($riskLevel, $riskAssessmentConfig)};
  color: ${({ $riskLevel, $riskAssessmentConfig }) =>
    getRiskColor($riskLevel, $riskAssessmentConfig)};
  display: inline-block;
  min-width: 44px;
  padding: 0.2em 0.7em;
  border-radius: 6px;
  font-weight: 700;
  font-size: 0.95em;
  text-align: center;
  letter-spacing: 1px;
  cursor: ${({ $clickable }) => ($clickable ? 'pointer' : 'default')};
`

interface RiskBadgeProps {
  riskValue?: number
  riskAssessmentConfig?: GeckoRiskAssessmentConfig
  className?: string
  onClick?: (e?: React.MouseEvent) => void
}

export const RiskBadge: React.FC<RiskBadgeProps> = ({
  riskValue,
  riskAssessmentConfig,
  className,
  onClick,
}) => {
  if (riskValue === 0 || isNil(riskValue)) {
    return (
      <Badge
        $riskLevel='0'
        $riskAssessmentConfig={riskAssessmentConfig}
        $clickable={!!onClick}
        className={className}
        onClick={onClick}>
        ---
      </Badge>
    )
  }

  const riskLevel = mapRiskScoreToRiskClass(riskValue, riskAssessmentConfig)

  return (
    <Badge
      $riskLevel={riskLevel}
      $riskAssessmentConfig={riskAssessmentConfig}
      $clickable={!!onClick}
      className={className}
      onClick={onClick}>
      {getRiskLevelText(riskLevel)}
    </Badge>
  )
}
